import getStripeAccount from './get-stripe-account';

export default function getStripeDashboardUrl(
  path = '',
  { seller, isAdminLoggedInAsSeller } = {},
) {
  // if viewing as admin, return link with stripeAccount
  if (isAdminLoggedInAsSeller) {
    const stripeAccount = getStripeAccount(seller);

    if (stripeAccount) {
      return `https://dashboard.stripe.com/${stripeAccount}${path}`;
    }
  }

  return `https://dashboard.stripe.com${path}`;
}
